@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.FieldsetDescriptionButton {
  @extend %font-family-primary;

  border: none;
  background: none;
  color: $theme-color-text;
  cursor: pointer;
  font-weight: $font-weight-normal;
  padding: 2px;
  align-items: baseline;

  span {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    border-radius: 3px;
  }

  &:hover {
    background: $theme-color-info-hover;
    border-radius: 8px;
    box-shadow: 0 0 0 2px $theme-color-info-hover;
  }

  &:active {
    background: $theme-color-info-active;
    border-radius: 8px;
    box-shadow: 0 0 0 2px $theme-color-info-active;
  }

  svg {
    color: $theme-color-text;
  }
}
